var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"bottom-right",on:{"click":_vm.scrollTop}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }